// Copy paste this template to create a new component
// that can be put into the masonry layout!

import * as React from "react";
import { css } from "emotion";
import Card from "./Card";
import { Line, defaults, Bar } from "react-chartjs-2";
import { labeledStatement } from "@babel/types";

const barChartOptions = {
  maintainAspectRatio: false,
  responsive: true,
  legend: {
    display: true,
    // onClick: null
  },
  datasets: {
    line: {
      tension: 0,
      fill: false
    }
  },
  scales: {
    xAxes: [
      {
        display: true,
        position: "bottom",
        scaleLabel: {
          display: true,
          labelString: "Year"
        }
      }
    ],
    yAxes: [
      {
        ticks: {
          callback: function(label) {
            if (/\s/.test(label)) {
              if (label.split(" ").length > 2) {
                label = label.split(" ");
                label[1] = label[0] + " " + label[1];
                label.shift();
                return label.map(l => l + '%');
              } else {
                return label.split(" ").map(l => l + '%');
              }
            } else {
              return label + '%';
            }
          }
        },
        stacked: false,
        display: true,
        scaleLabel: {
          display: true,
          labelString: "Percent of Students"
        }
      }
    ]
  },
  title: {
    display: false,
    text: "Accepted Fall 2019 vs Fall 2020 Interns Gender Breakdown"
  },
  tooltips:{
    callbacks:{
      label: function(tooltipItem){
        return this._data.datasets[tooltipItem.datasetIndex].label +': ' + tooltipItem.yLabel + '%';
      }
    }
  }
};

interface InternGenderProps{
  caption: Array<string>;
}

class EthnicityBreakdownBarChartCard extends React.Component<InternGenderProps> {
  constructor(props:InternGenderProps){
    super(props);
  }
  state = {
    //using this as the data
    //hardcoded in 2020 bc couldn't make google sheets work
    labels: ["Fall 2019", "Fall 2020", "Fall 2021", "Fall 2022", "Fall 2023", "Winter 2024"],
    borderWidth: 1,
    datasets: [
      { data: [66.1,72.5,64.9,69.31,(40/51*100).toFixed(2),(30/43*100).toFixed(2)], borderColor: "#48A2D3", backgroundColor: "#48A2D3", label: "Woman" },
      { data: [32.8,25.0,32.8,28.71,(9/51*100).toFixed(2),(13/43*100).toFixed(2)], borderColor: "#F0A202", backgroundColor: "#F0A202", label: "Man" },
      { data: [0,0.83,1.5,.99,(2/51*100).toFixed(2),(0/43*100).toFixed(2)], borderColor: "#5DBD5B", backgroundColor: '#5DBD5B', label: "Nonbinary"},
      { data: [0,.42,.74,0,(0/51*100).toFixed(2),(0/43*100).toFixed(2)], borderColor:'#733B90', backgroundColor: '#733B90', label: "Other"},
      { data: [1,1.25,0,.99,(0/51*100).toFixed(2),(0/43*100).toFixed(2)], borderColor:'#E84855', backgroundColor: '#E84855', label: "Prefer not to say"}
    ]
  };

  /*
  Gender,2019,2020,2021
  Woman,66.1,72.5,64.9
  Man,32.8,25.0,32.8
  Nonbinary,0,0.83,1.5
  Prefer not to say,1,1.25,0
  Agender, NaN,.42, 0
  Transmasculine,0,0,.74
  */

  //collect the data
  collect_data = () => {
    // fetch(
    //   "https://spreadsheets.google.com/feeds/list/1P3ojuD3Rv8ZoTBUuNwEaOIkOodfRnybhahVnA9tl44E/od6/public/full?alt=json"
    // )
    //   .then(function(response) {
    //     return response.json();
    //   })
    //   .then((response_json: any) => {
    //     var labels = response_json.feed.entry.slice(0, 4).map((e: any) => {
    //       //console.log(e.gsx$section.$t);
    //       return e.gsx$gender.$t;
    //     });
    //     var values1 = response_json.feed.entry.slice(0, 4).map((e: any) => {
    //       //console.log(e.gsx$productsproduced.$t);
    //       return e.gsx$applicantgenderpercent.$t;
    //     });
    //     var values2 = response_json.feed.entry.slice(0, 4).map((e: any) => {
    //       //console.log(e.gsx$productsproduced.$t);
    //       return e.gsx$interngenderpercent.$t;
    //     });

    //     this.setState({
    //       labels: labels,
    //       datasets: [
    //         { data: values1, backgroundColor: "#0080C6", label: "Applicants" },
    //         {
    //           data: values2,
    //           backgroundColor: "#48A2D3",
    //           label: "Accepted Interns"
    //         }
    //       ]
    //     });
    //   })
    //   .catch(function(err) {
    //     console.log("something went wrong!", err);
    //   });
  };
  render() {
    //this.collect_data();
    defaults.global.defaultFontColor = "#0a0a0a";
    const caption = this.props.caption;
    return (
      <Card>
        <div
          className={css`
            font-size: 30px;
            text-align: center;
            margin-bottom: 5px;
            @media (max-width: 700px) {
              font-size: 18px;
            }
          `}
        >
          Interns gender breakdown
        </div>
        <div
          className={css`
            height: 400px;
            width: 100%;
          `}
        >
          <Line
            data={this.state}
            options={{
              ...barChartOptions
            }}
          />
        </div>
        <div className={css`
            font-size: 15px;
            margin: 10px;
            color: black;
            text-align: left;
          `}>
            {caption}
        </div>
      </Card>
    );
  }
}

export default EthnicityBreakdownBarChartCard;
